export const EDIT_STATE =
  process.env.REACT_APP_HOST === undefined ? false : true;

export const API_ADDRESS =
  process.env.REACT_APP_HOST === undefined
    ? "https://feef9sgd3b.execute-api.us-east-1.amazonaws.com/dev/"
    : "http://localhost:3000/dev/";
